function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import icSuccessIcon from 'assets/svg/ic_success.svg';
import icClose from 'assets/svg/ic_close.svg';
import { formatCurrency } from '@wolffun/system-currency';
import { formatDateTime } from 'src/utils/date';
import Modal from 'src/Components/Modal';
import Button from '../../Components/Button';
import TradingEventAds from './TradingEventAds';
import { useTestId } from '@wolffun/testable-id';

const TransactionDetailModal = ({
  heroId,
  heroName,
  price,
  onClose,
  hasSpecialEvent,
  heroEvent
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", _extends({
    className: styles.modal
  }, generateTestIdProps('success-modal')), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccessIcon
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Complete!"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "You successfully purchase #", heroId, " ", heroName, " Hero"), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Total Price"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, price ? formatCurrency(price, {
    withCurrency: true
  }) : undefined)), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Time"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatDateTime(new Date()))), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Close",
    onClick: onClose
  })), hasSpecialEvent && /*#__PURE__*/React.createElement(TradingEventAds, {
    hasEvent: heroEvent
  })));
};

export default TransactionDetailModal;